import Vuex from 'vuex'

const requireModules = require.context('./modules/', true, /index\.(ts|js)$/iu)

const modules = {}

requireModules.keys().forEach(filePath => {
    const modular = requireModules(filePath)
    const name = filePath.replace(/\.\/|\/index.(js|ts)/g, '')
    modules[name] = {
        namespaced: true,
        ...modular.default
    }
})



const store = new Vuex.Store({
    //在这里控制
    modules: {
        ...modules
    },
    actions: {
        /**
         * 清除数据 用户信息 菜单 权限 标签页 主题
         * @param {*}
         */
        clearData({ dispatch }) {

        },
        /**
         * 清除缓存
         * @returns
         */
        clear({ dispatch }) {

            window.location.reload()
        },
        /**
         * 退出登录清除 用户信息 菜单 权限 登录凭证
         * @param {*} param0
         */
        logout({ dispatch }) {

        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js